<template>
    <q-btn-group v-bind="$attrs">
        <q-btn
                size="sm"
                :icon="orderIcon"
                :title="orderTitle"
                :color="isSelected('lastName') ? this.selectedColor : this.nonSelectedColor"
                text-color="black"
                @click="change('lastName')" />
        <q-btn
                size="sm"
                label="Unreviewed"
                :color="isSelected('totalUnreviewed') ? this.selectedColor : this.nonSelectedColor"
                text-color="black"
                @click="change('totalUnreviewed')"/>
        <q-btn
                size="sm"
                label="Escalated"
                :color="isSelected('totalEscalated') ? this.selectedColor : this.nonSelectedColor"
                text-color="black"
                @click="change('totalEscalated')"/>
    </q-btn-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['order-by-changed', 'order-changed'],
  props: {
    orderBy: {
      type: String,
      default: 'lastName',
    },
    order: {
      type: String,
      default: 'asc',
    },
  },
  computed: {
    selectedColor(): string {
      return 'light-blue-1';
    },
    nonSelectedColor(): string {
      return 'grey-1';
    },
    orderIcon(): string {
      if (this.isAscending) {
        return 'fas fa-sort-alpha-down';
      }
      return 'fas fa-sort-alpha-up';
    },
    orderTitle(): string {
      return (this.isAscending) ? 'Ascending' : 'Descending';
    },
    oppositeOrder(): string {
      return (this.isAscending) ? 'desc' : 'asc';
    },
    isAscending(): Boolean {
      return (this.order === 'asc');
    },
  },
  methods: {
    isSelected(order: string): Boolean {
      return (this.orderBy === order);
    },
    change(orderBy: string): void {
      if (this.orderBy === orderBy) {
        this.$emit('order-changed', this.oppositeOrder);
      }
      this.$emit('order-by-changed', orderBy);
    },
  },
});
</script>
